import Styles from './PostApproval.module.scss'
import { Button } from 'blaze-ui/Button'
import { useOpenIntegrations } from 'hooks/useOpenIntegrations'
import UserProfileAdd2 from 'blaze-ui/icons/20/UserProfileAdd2'

export const ConnectButton = () => {
  const openIntegrations = useOpenIntegrations()

  return (
    <div className={Styles.buttons}>
      <Button fullWidth frontIcon={UserProfileAdd2} onPress={openIntegrations}>
        Connect Accounts
      </Button>
    </div>
  )
}
